import { requireRouteAudience } from '@services/router/routeAccess'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/staff/staff-directory')({
    component: RouteComponent,
    beforeLoad: requireRouteAudience(['staff', 'student']),
})

function RouteComponent() {
  return <div>Hello "/_layout/staff/staff-directory"!</div>
}
